import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import Fade from '@mui/material/Fade';

import { CloseButton as CloseButtonBase } from '~/src/components/buttons/CloseButton';
import { useIsSSR } from '~/src/components/hooks/useIsSSR';

const Container = styled.div`
  width: 100%;
  align-items: center;
  justify-items: center;
  color: white;
  display: flex;
  flex-direction: row;
  overflow: hidden;
`;

const Content = styled.div`
  flex: 1;
`;

const CloseButton = styled(CloseButtonBase)`
  grid-area: closeBtn;
  width: 14px;
  height: 14px;
`;

interface Props {
  isShown: boolean;
  onClose?: () => void;
  className?: string;
}

export const SiteWideBanner: React.FC<PropsWithChildren<Props>> = ({
  isShown,
  onClose,
  children,
  ...props
}) => {
  const isSSR = useIsSSR();

  if (isSSR) {
    return null;
  }

  return (
    <Fade in={isShown} unmountOnExit>
      <Container {...props}>
        <Content>{children}</Content>
        {onClose && <CloseButton onClick={onClose} />}
      </Container>
    </Fade>
  );
};
